"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MarkDownIslandType;
(function (MarkDownIslandType) {
    MarkDownIslandType["Informative"] = "Informative";
    MarkDownIslandType["Important"] = "Important";
    MarkDownIslandType["Full"] = "Full";
    MarkDownIslandType["Errorr"] = "Errorr";
})(MarkDownIslandType = exports.MarkDownIslandType || (exports.MarkDownIslandType = {}));
//# sourceMappingURL=MarkDownIslandType.js.map